var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-search animated fadeIn roundedCard" },
    [
      _c("b-card", [
        _c("h1", { staticClass: "lbv-page-title" }, [
          _vm._v("\n      Disable Chasers\n    "),
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "lbv-search-filter",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.disableInstallChasers.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "b-row",
              {
                staticClass:
                  "d-flex w-100 align-items-center justify-content-between",
              },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Email Address",
                          "label-for": "email-address",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.emailString,
                              expression: "emailString",
                            },
                          ],
                          staticClass: "form-control w-100",
                          attrs: {
                            if: "email-address",
                            type: "text",
                            required: "",
                          },
                          domProps: { value: _vm.emailString },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.emailString = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "6" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary applyFilter",
                        attrs: { id: "applyBtn", type: "submit" },
                      },
                      [_vm._v("\n            Submit\n          ")]
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }